export class ActivityUtil {
  public static RM_MODE = "RM";
  public static FODDER_MODE = "FO";
  private static ALLOWED_ACTIVITY_MODE = [ this.RM_MODE, this.FODDER_MODE ];

  /**
   * Check is the activity code is a RM Mode
   * @param activityCode the activity code to check
   * @returns true if the activity code is a RM one
   */
  static isRmMode(activityCode: string): boolean {
    return activityCode === this.RM_MODE;
  }

  /**
   * Check is the activity code is for a fodder mode
   * @param activityCode the activity code to check
   * @returns true if the activity code is a fodder one
   */
  static isFodderActivityCode(activityCode: string): boolean {
    return activityCode === this.FODDER_MODE;
  }

  /**
   * Check if the activity code is an allowed one for MatrixNutri
   * @param activityCode the activity code to check
   * @returns true if the activity code is an allowed one
   */
  static isAllowedActivityCode(activityCode: string): boolean {
    return this.ALLOWED_ACTIVITY_MODE.includes(activityCode);
  }
}
